import { CognitoAuthProvider } from 'ra-auth-cognito'
import { CognitoUserPool } from 'amazon-cognito-identity-js'

import cognitoJson from './cognito.json'
import { isNil } from 'lodash/fp'
import { type AuthProvider } from 'react-admin'

export const userCognitoAuthProvider = (
  partnerId: string
): AuthProvider | undefined => {
  const env = process.env['ENV'] as string
  const cognito = cognitoJson[env as keyof typeof cognitoJson]
  const { userPoolId: UserPoolId, clientId: ClientId } = cognito[partnerId]
  if (isNil(UserPoolId) || isNil(ClientId)) {
    return undefined
  }
  const userPool = new CognitoUserPool({
    UserPoolId,
    ClientId
  })
  return CognitoAuthProvider(userPool)
}
